/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BucketModeEnum } from './bucketModeEnum';


export interface S3BucketDetail { 
    /**
     * S3 bucket ARN
     */
    bucket_arn?: string;
    bucket_mode?: BucketModeEnum;
    /**
     * Cloud Account Id which owns the S3 bucket
     */
    cloud_account_id?: string;
}
export namespace S3BucketDetail {
}


